import React, { Component } from 'react'
import Modal from './Modal'
import styled from 'styled-components'
import { LogeButtonSlim } from '../../GeneralStyle'
import { inject, observer } from 'mobx-react';
import Parse from 'parse'
import { Form, Input } from 'formsy-react-components';
import { Row, Col } from 'react-bootstrap';
import ReactDOM from 'react-dom';
// import parse from 'html-react-parser';

class PreviewContractModal extends Component {

  constructor(props) {
		super(props)

    this.state = {
      html: "",
      data: {},
    }

    Parse.Cloud.run("getContractHTML").then(html => {
      this.setState({html})
      this.setData()
    }).catch(err => console.error(err))
  }

  open = () => {
    this.child.open()
    this.forceUpdate()
  }

	componentDidUpdate(prevProps) {
  	if (prevProps.contract !== this.props.contract) {
      this.setData()
    }
	}

  setData = async () => {
    const { contract } = this.props
    let data = {}
    const date = new Date()

    if(!contract) {

      const config = await Parse.Config.get()
      const amount = await config.get("YEARLY_FEE")
      const year = await config.get("CURRECT_BILLING_YEAR")

      data = {
        companyName: "Musterfirma",
        location: "Wien",
        billingAddress: "Musterstraße 10",
        nettoBetrag: amount,
        ustBetrag: amount * 0.2,
        bruttoBetrag: amount * 1.2,
        ustValue: 20,
        startDate: "1.1." + year,
        endDate: "31.12." + year,
        cancelDate: "30.10." + year,
        nextYearDate: "31.12." + (year + 1),
        currentDate: `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`,
      }
    } else {
      const { company } = contract

      let vat = ( contract && contract.company && contract.company.region && contract.company.region.country && contract.company.region.country.taxrate ) || 0.2

      data = {
        companyName: company.name,
        location: company.location,
        billingAddress: company.billingAddress,
        nettoBetrag: contract.fee,
        ustBetrag: contract.fee * vat,
        bruttoBetrag: contract.fee * (1 + vat),
        ustValue: vat * 100,
        startDate: "1.1." + contract.year,
        endDate: "31.12." + contract.year,
        cancelDate: "30.10." + contract.year,
        nextYearDate: "31.12." + (contract.year + 1),
        currentDate: `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`,
      }

    }

    await this.setState({ data })
    this.updateHtml()
  }

  updateHtml = () => {
    const iframeElement = this.refs.htmlcontainer

    let html = this.state.html;
    let data = this.state.data

    for(const property in data) {
      html = html.replace(new RegExp("{{"+property+"}}", 'g'), data[property])
    }

    iframeElement.src = "about:blank";
    iframeElement.contentWindow.document.open();
    iframeElement.contentWindow.document.write(html);
    iframeElement.contentWindow.document.close();
  }

  render() {
    return (
      <Modal width="auto" ref={instance => { this.child = instance; }} modalStyles={{maxHeight: "90vh", height: "22.3cm", padding: 0, overflowY: "hidden", transform: window.innerWidth > 1920 ? "scale(1.2)" : ""}}>
        <iframe ref="htmlcontainer" style={{width: "15.5cm", height: "100%", border: "none"}}></iframe>
      </Modal>
    )
  }
}

export default PreviewContractModal;



// WEBPACK FOOTER //
// /src/components/internal/Modals/PreviewContractModal.js